import commonApi from '@/http/common/api'
import userApi from '@/http/user/api'
import tbkApi from '@/http/tbk/api'
import pddApi from '@/http/pdd/api'
import jdApi from '@/http/jd/api'
import vphApi from '@/http/vph/api'
export default {
  common: commonApi,
  user: userApi,
  tbk: tbkApi,
  pdd: pddApi,
  jd: jdApi,
  vph: vphApi,
}